import { useTheme } from "@/context/theme-context";

interface Props {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  const { effectiveTheme } = useTheme();

  return (
    <div className='container grid flex-col items-center justify-center h-svh bg-background lg:max-w-none lg:px-0'>
      <div className='mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[480px] lg:p-8'>
        <div className='flex items-center justify-center mb-2'>
          <img
            src={
              effectiveTheme === 'dark'
                ? "/images/logo-light.svg"
                : "/images/logo-dark.svg"
            }
            alt="Wazai Logo"
            className="w-60"
          />
        </div>
        {children}
      </div>
    </div>
  )
}
